import Modal from 'bootstrap/js/src/modal';
import EventHandler from 'bootstrap/js/src/dom/event-handler';
import SelectorEngine from 'bootstrap/js/src/dom/selector-engine';

/**
 * ------------------------------------------------------------------------
 * Constantes
 * ------------------------------------------------------------------------
 */

const EVENT_KEY = '.app';

const Event = {
  CLICK: `click${EVENT_KEY}`,
  LOAD: `load${EVENT_KEY}`
};

const Selector = {
  MODAL_CONTENT: '.modal-content',
  SCREENSHOT_MODAL: '#screenshotModal',
  DATA_TOGGLE_SCREENSHOT: '[data-toggle="screenshot"]'
};

function initScreenshotModal(element) {
  if (!element) {
    return;
  }

  const modal = new Modal(element, { show: false });
  const modalContent = SelectorEngine.findOne(Selector.MODAL_CONTENT, element);

  EventHandler.on(document, Event.CLICK, Selector.DATA_TOGGLE_SCREENSHOT, function () {
    modalContent.innerHTML = `<img src="${this.src}" class="img-fluid" alt="${this.getAttribute('alt')}">`;
    modal.show();
  });
}

/**
 * ------------------------------------------------------------------------
 * Application principale
 * ------------------------------------------------------------------------
 */

EventHandler.on(window, Event.LOAD, () => {
  // Supprime la classe .no-js une fois la page chargée
  document.documentElement.classList
    .remove('no-js');

  initScreenshotModal(SelectorEngine.findOne(Selector.SCREENSHOT_MODAL));
});
